import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Card, Tabs } from 'antd';
import VerificationCode from '../../../Login/VerificationCode';
import Password from '../../../Login/Password';
import ForgetPassword from '../../../Login/ForgetPassword';
import s from '../../../Login/style.m.less';
import InformationModal from '../InformationModal';
import withRouter from '@/components/withRouter';
import GrtLoading from '@/components/GrtLoading/GRTLoading';
import style from './style.m.less';
@inject('store')
@observer
class Qhb extends Component {
    state = {
        loading: true
    };
    async componentDidMount() {
        const {
            store: { login }
        } = this.props,
         competition_id = this.props.params?.id || '';
        login.setQhbMode('city');
        // 2025年启航杯登录后跳转到2025年专题页 /2025/city_qhb_tenant/:id
        login.setRedirectUrl(`https://${window.location.host}/web/2025/city_qhb_tenant/${competition_id}`);
        const isLogin = await login.checkLogin();
        if (isLogin) {
            return login.loginCallback(null,'competition');
        }
        this.setState({
            loading: false
        });
    }
    onChange = (activeKey) => {
        const {
            store: { login }
        } = this.props;

        login.setActiveKey(activeKey);
    };

    render() {
        const {
            store: { login }
        } = this.props;

        return this.state.loading ?
        <GrtLoading /> :
        <div className={`${s.competition_app} ${style.city_app}`}>
            <div className={style.city_competition_logo}>
                <div className={style.city_login_wrap}>
                    <div className={s.login_logo}></div>
                    <div className={style.city_competition_content}>
                        <Card hoverable>
                            {login.mode === 'login' ? (
                                <Tabs
                                    onChange={this.onChange}
                                    activeKey={login.activeKey}
                                    items={[
                                        {
                                            key: 'code',
                                            label: '验证码登录',
                                            children: <VerificationCode type="competition" />
                                        },
                                        {
                                            key: 'password',
                                            label: '密码登录',
                                            children: <Password type="competition" />
                                        }
                                    ]}
                                />
                            ) : (
                                <ForgetPassword type="competition" />
                            )}
                        </Card>
                    </div>
                </div>
            </div>
            <div className={style.footer}>
                <div
                    style={{
                        width: '1200px',
                        height: '112px',
                        margin: '0 auto',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    <div className={style.footer_logo}></div>
                    <div className={style.footer_text}>
                        <div style={{ marginBottom: '8px' }}>
                            主办单位：北京教育学院 <span style={{ marginLeft: '30px', display: 'inline-block' }}>北京市特级教师协会</span>
                            <span style={{ marginLeft: '30px', display: 'inline-block' }}> 北京市学前儿童保教工作者协会</span>
                        </div>
                        <div>技术支持：北京国人通教育科技有限公司</div>
                    </div>
                </div>
            </div>
            <InformationModal />
        </div>;
    }
}

export default withRouter(Qhb);
